export default {
  isOnline: true,
  scanner: {
    connected: false,
    value: ''
  },
  main: {
    color: 'black'
  }
};
